<template>
    <div>
        <div id="print" class="d-flex flex-wrap">
            <div id="printObj">
                <div>
<!--                    <label class="binLabel">bin位码</label>-->
                    <img class="binImg" :src="entity.src" alt="图片找不到了。。。。"/><br/>
                    <label class="binLabel">{{this.entity.storageBin}}</label>
                </div>
            </div>
            <br/>
            <el-button v-print="'#printObj'" class="print-btn ml-1" v-if="!isMobileDevice">桌面端打印Bin码</el-button>
            <el-button type="primary" class="print-btn ml-1" v-if="isMobileDevice" @click="openApp('?'+'storageBin='+entity.storageBin+'&storageLoc='+entity.storageLoc+'&storageType='+entity.storageType)">
                移动端蓝牙打印Bin码
            </el-button>
            <el-button type="primary" class="print-btn ml-2" v-if="isMobileDevice" @click="downloadApp()">
                下载移动端最新app
            </el-button>
        </div>
    </div>


</template>

<script>

    import emCommonListMixin from "@/mixin/em/common/list";
    import emCommonApiMixin from "@/mixin/em/common/api";

    let timer;
    export default {
        name: "PrintView",
        data: function () {
            return {
                type: 'pc',
                ua : window.navigator.userAgent.toLowerCase(),
                androidSchemeUrl:'siemens://sithmom:9999/print',
                iosSchemeUrl:'',
                androidDownloadUrl:'https://pan.baidu.com/s/1lvSudBwWCYpjTME1GlmBLA?pwd=5r18',
                iosDownloadUrl:'',
                picture: '',
                entity: {},
            };
        },
        components: {},
        mixins: [emCommonListMixin, emCommonApiMixin],
        computed: {
            isMobileDevice() {
                return /iphone|ipad|ipod/.test(this.ua) || /android/.test(this.ua);
            },
        },
        methods: {
            getPicture(item) {
                let that = this;
                let _url = `${this.$_emApiMixin_entityBaseApi("sithMesInventoryItem")}/getBinQrPicture`;
                this.$_emApiMixin_post(_url, item).then((data) => {
                    that.$set(item, 'src', data.data);
                });
            },
            watchVisibility() {
                window.addEventListener('visibilitychange', () => {
                    // 监听页面visibility
                    if(document.hidden && timer != null) {
                        // 如果页面隐藏了，则表示唤起成功，这时候需要清除下载定时器
                        clearTimeout(timer)
                    }
                })
            },
            //判断是否为微信浏览器
            isWeiXin() {
                return this.ua.match(/MicroMessenger/i) == "micromessenger" || this.ua.match(/_SQ_/i) == "_sq_";
            },
            //打开app
            openApp(data) {
                if (/iphone|ipad|ipod/.test(this.ua)) {
                    this.type = "ios";

                } else if (/android/.test(this.ua)) {
                    this.type = "android";
                }
                if (!this.isWeiXin()) {
                    switch (this.type) {
                        case "pc": {
                            break;
                        }
                        case "android": {
                            location.href = this.androidSchemeUrl + data;
                            let androidDownloadUrl = this.androidDownloadUrl;
                            timer = setTimeout(function () {
                                window.location.href = androidDownloadUrl;
                            }, 5000);
                            break;
                        }
                        case 'ios': {
                            location.href = this.iosSchemeUrl + data;
                            let iosDownloadUrl = this.iosDownloadUrl;
                            timer = setTimeout(function () {
                                window.location.href = iosDownloadUrl;
                            }, 5000);
                            break;
                        }
                        default: {
                            break;
                        }
                    }
                }
            },
            downloadApp() {
                window.location.href = this.androidDownloadUrl;
            },

        },
        mounted() {
            this.entity = this.$route.query;
            this.getPicture(this.entity);
            this.watchVisibility();
        }
    }
</script>

<style>

    @page {
        size: 120mm 90mm !important;
    }

    @media print {
        .printPage {
            page-break-after: always;
            margin: 4px !important;
            width: 580px;
        }

        .printPage:last-child {
            page-break-after: auto;
        }

        input {
            border: none;
        }

        #printObj {
            height: auto;
            width: 580px;
            margin: 2px !important;
        }

        .print-btn {
            visibility: hidden;
        }


    }

    #printObj {
        height: auto;
        width: 580px;
        margin: 80px;
        text-align: center;
    }

    .binImg {
        width: 320px;
        height: 320px;
    }

    .binLabel {
        font-size: 60px;
        text-align: center;
        width: 320px;
        margin: 5px;
    }

    .print-btn{
        height: min-content;
        margin-top: 80px !important;
    }

</style>
